import React, { FC, ChangeEvent } from 'react';
import { Field, FieldProps } from 'formik';
import { FormControlLabel, FormControlLabelProps, Switch, SwitchProps } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

interface IProps extends WithStyles<typeof styles> {
  name: string;
  color?: SwitchProps['color'];
  customColor?: 'orange';
  label?: FormControlLabelProps['label'];
  labelPlacement?: FormControlLabelProps['labelPlacement'];
  labelClasses?: object;
  disabled?: boolean;
  checkedFn?: (value: unknown) => boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>, value: boolean) => void;
}

const styles = (theme: Theme) =>
  createStyles({
    active: {
      color: theme.palette.text.primary,
    },
    inactive: {
      color: theme.palette.text.secondary,
    },
    orangeSwitch: {
      '&$colorChecked': {
        color: theme.custom.palette.orange,
        '& + $colorBar': {
          backgroundColor: theme.custom.palette.orange,
        },
      },
    },
    colorBar: {},
    colorChecked: {},
  });

const ValidatedSwitch: FC<IProps> = props => {
  const {
    name,
    classes,
    color,
    checkedFn,
    customColor,
    disabled,
    label,
    labelPlacement,
    labelClasses,
    onChange,
  } = props;
  let colorProps: SwitchProps = { color };

  if (customColor === 'orange') {
    colorProps = {
      classes: {
        switchBase: classes.orangeSwitch,
        checked: classes.colorChecked,
        track: classes.colorBar,
      },
    };
  }

  return (
    <Field
      name={name}
      render={({ field }: FieldProps) => {
        const checked = checkedFn(field.value);

        return (
          <FormControlLabel
            label={label}
            disabled={disabled}
            labelPlacement={labelPlacement}
            classes={{ label: checked ? classes.active : classes.inactive, ...labelClasses }}
            control={
              <Switch
                name={name}
                checked={checked}
                onChange={(event, nextValue) => {
                  onChange ? onChange(event, nextValue) : field.onChange(event);
                }}
                {...colorProps}
              />
            }
          />
        );
      }}
    />
  );
};

ValidatedSwitch.defaultProps = {
  color: 'primary',
  customColor: null,
  disabled: false,
  label: null,
  labelPlacement: 'start',
  checkedFn: (value: boolean) => !!value,
};

export default withStyles(styles)(ValidatedSwitch);
